import type { FC, PropsWithChildren } from 'react'

import type { TrProps } from './types'

export type TrLinkProps = TrProps & {
  path: string
  onNavigate: (path: string) => void
}

export const TrLink: FC<PropsWithChildren<TrLinkProps> & { 'data-tooltip-id'?: string }> = ({
  children,
  id,
  className,
  path,
  onNavigate,
  onMouseOut,
  onMouseOver,
  ...props
}) => (
  <tr
    id={id}
    className={`tr-link ${className}`}
    role="button"
    tabIndex={0}
    onKeyDown={e => {
      if (e.key === 'Enter') {
        onNavigate(path)
      }
    }}
    onClick={() => onNavigate(path)}
    onMouseOver={e => onMouseOver?.(e)}
    onMouseOut={onMouseOut}
    onFocus={e => onMouseOver?.(e)}
    onBlur={e => onMouseOut?.(e)}
    {...props}
  >
    {children}
  </tr>
)
